import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import AuthPage from './pages/AuthPage';
import Dashboard from './pages/Dashboard';
import VenuesPage from './pages/VenuesPage';
import EventsPage from './pages/EventsPage';
import FinancialsPage from './pages/FinancialsPage';
import ContactsPage from './pages/ContactsPage';
import MailingListPage from './pages/MailingListPage';
import SettingsPage from './pages/SettingsPage';
import AboutPage from './pages/AboutPage';
import MaaikePage from './pages/MaaikePage';
import ArtistsPage from './pages/ArtistsPage';
import ArtistApplyPage from './pages/ArtistApplyPage';
import CRMPage from './pages/CRMPage';
import Layout from './components/Layout';
import { useAuth } from './utils/auth';

function App() {
  const { isAuthenticated, login, logout, loading } = useAuth();
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="text-white text-xl font-light">Loading...</div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/auth" element={
        isAuthenticated ? <Navigate to="/dashboard" /> : <AuthPage onLogin={login} />
      } />
      
      <Route path="/" element={
        isAuthenticated ? <Layout onLogout={logout} /> : <Navigate to="/auth" />
      }>
        <Route index element={<Navigate to="/dashboard" />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="venues" element={<VenuesPage />} />
        <Route path="events" element={<EventsPage />} />
        <Route path="financials" element={<FinancialsPage />} />
        <Route path="contacts" element={<ContactsPage />} />
        <Route path="mailing-list" element={<MailingListPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="maaike" element={<MaaikePage />} />
        <Route path="artists" element={<ArtistsPage />} />
        <Route path="crm" element={<CRMPage />} />
      </Route>
      
      {/* Public routes */}
      <Route path="/artists/apply" element={<ArtistApplyPage />} />
    </Routes>
  );
}

export default App;
